<app-main-header></app-main-header>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
<app-main-footer></app-main-footer>
<app-confirm-dialog></app-confirm-dialog>